// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__pzRC7","border_anim":"styles_border_anim__2qDWQ"};